<template lang="pug">
  .cart-product-summary(v-if="articlePivots.length" :class="{ invalid: !valid, 'not-available': !available }")
    router-link.info.margin-top(:to="route")
      .text-box
        h3.title {{ product.name }}
        h3.nr {{ product.nr }}
        //- .description(v-if="product.description" v-html="product.description")
    .price.gray.margin-top.text-right
      //- span(v-if="articlePivots.length === 1") {{ price | moneyFormat(currency) }}
    .qty.margin-top.text-center
      //- span(v-if="articlePivots.length === 1") {{ qty }}
    .sum.margin-top.text-right
      //- b(v-if="articlePivots.length === 1") {{ price * qty | moneyFormat(currency) }}
    .article-pivot(v-for="articlePivot in articlePivots" :class="{ 'not-available': !articlePivot.available }")
      .property-values
        router-link.main-media(v-if="articlePivot.mainMedia && articlePivot.mainMedia.type === 'image'" :to="route")
          Thumbnail(
            :key="articlePivot.mainMedia.id"
            :media="articlePivot.mainMedia"
            :height="46"
          )
        .property-value(v-for="propertyPivot in articlePivot.propertyPivots")
          .small {{ propertyPivot.property.name }}
          b {{ propertyPivot.value }}
      .price.gray.text-right
        template(v-if="customer && customer.show_net_prices")
          //- nobr(v-if="articlePivots.length > 1 && articlePivot.price") {{ articlePivot.price.net_value | moneyFormat(currency) }}
          nobr(v-if="articlePivot.price" :class="{ strikethrough: articlePivot.salePrice }") {{ articlePivot.price.net_value | moneyFormat(currency) }}
          nobr.sale(v-if="articlePivot.salePrice") {{ articlePivot.salePrice.net_value | moneyFormat(currency) }}
          //- nobr(v-else) {{ articlePivot.price.net_value | moneyFormat(currency) }}
        template(v-else)
          //- nobr(v-if="articlePivots.length > 1 && articlePivot.price") {{ articlePivot.price.value | moneyFormat(currency) }}
          nobr(v-if="articlePivot.price" :class="{ strikethrough: articlePivot.salePrice }") {{ articlePivot.price.value | moneyFormat(currency) }}
          nobr.sale(v-if="articlePivot.salePrice") {{ articlePivot.salePrice.value | moneyFormat(currency) }}
          //- nobr(v-else) {{ articlePivot.price.value | moneyFormat(currency) }}
      .qty.text-center
        //- span(v-if="articlePivots.length > 1 && articlePivot.qty") {{ articlePivot.qty }}
        span(v-if="articlePivot.qty") {{ articlePivot.qty }}
        .buttons
          button.button.is-small.is-link.decrease(@click.prevent.stop="decrease(articlePivot)")
            template(v-if="articlePivot.qty > 1 && (articlePivot.available || articlePivot.article.qty_sum > 0)")
              svg(xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor")
                path(stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 12H4")
            template(v-else)
              svg(xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor")
                path(stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16")
          button.button.is-small.is-link.increase(
            :disabled="!articlePivot.available || articlePivot.qty_at_limit"
            @click.prevent.stop="increase(articlePivot)"
          )
            svg(xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor")
              path(stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6")
      .sum.text-right
        template(v-if="customer && customer.show_net_prices")
          //- b(v-if="articlePivots.length > 1 && articlePivot.price && articlePivot.qty") {{ articlePivot.price.net_value * articlePivot.qty | moneyFormat(currency) }}
          b.sale(v-if="articlePivot.salePrice && articlePivot.qty") {{ articlePivot.salePrice.net_value * articlePivot.qty | moneyFormat(currency) }}
          b(v-else-if="articlePivot.price && articlePivot.qty") {{ articlePivot.price.net_value * articlePivot.qty | moneyFormat(currency) }}
        template(v-else)
          //- b(v-if="articlePivots.length > 1 && articlePivot.price && articlePivot.qty") {{ articlePivot.price.value * articlePivot.qty | moneyFormat(currency) }}
          b.sale(v-if="articlePivot.salePrice && articlePivot.qty") {{ articlePivot.salePrice.value * articlePivot.qty | moneyFormat(currency) }}
          b(v-else-if="articlePivot.price && articlePivot.qty") {{ articlePivot.price.value * articlePivot.qty | moneyFormat(currency) }}
    hr
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import { get, cloneDeep, orderBy } from '@/helpers';
import { moneyFormat } from '@/filters';

import Thumbnail from '@/extensions/shop/components/CheckoutStepper/Steps/Partials/Thumbnail.vue';

export default {
  name: 'CartProductSummary',
  props: {
    product: {
      type: Object,
      required: true
    },
    cartArticleMap: {
      type: Object,
      required: true
    }
  },
  components: {
    Thumbnail
  },
  filters: {
    moneyFormat
  },
  computed: {
    route() {
      return {
        name: 'product-details',
        params: {
          product: this.product.slug
        }
      };
    },
    currency() {
      return (
        get(this.customer, 'customerGroup.currency.iso4217') ||
        get(this.defaultCustomerGroup, 'customerGroup.currency.iso4217') ||
        'EUR'
      );
    },
    valid() {
      return !this.articlePivots.find(el => el.valid !== true);
    },
    available() {
      return !this.articlePivots.find(el => el.available !== true);
    },
    price() {
      let sum = 0;
      this.articlePivots.forEach(articlePivot => {
        if (this.customer && get(this.customer, 'show_net_prices')) {
          if (articlePivot.salePrice) {
            sum += articlePivot.salePrice.net_value;
          } else if (articlePivot.net_value) {
            sum += articlePivot.price?.net_value;
          }
        } else {
          if (articlePivot.salePrice) {
            sum += articlePivot.salePrice.value;
          } else if (articlePivot.price) {
            sum += articlePivot.price?.value;
          }
        }
      });
      return sum;
    },
    qty() {
      let sum = 0;
      this.articlePivots.forEach(articlePivot => {
        sum += articlePivot.qty;
      });
      return sum;
    },
    articlePivots() {
      let articlePivots = [];
      const articles = get(this.product, 'articles') || [];

      const getOptionValue = (option, propType) => {
        let key = propType.value_field;
        let value = get(option, key);
        if (!value) {
          key = propType.value_field_alt;
          value = get(option, key);
        }
        return value;
      };

      // let qtyMap = {};

      // find all articles which are in the cart
      articles.forEach(article => {
        if (this.cartArticleMap[article.id]) {
          // if (!qtyMap[article.id]) {
          //   qtyMap[article.id] = {
          //     stock: article.qty_sum,
          //     cart: 0
          //   }
          // }

          // go through all article variants (is possible of there are product related selectable attributes)
          this.cartArticleMap[article.id].forEach(el => {
            // let valid = true;
            let articlePivot = cloneDeep(el);
            articlePivot.article = article;

            // get the "main" media object (is marked for list view)
            // either from article or from product
            articlePivot.mainMedia =
              article.media.find(el => {
                return get(el, 'settings.show.list', true) === true && get(el, 'type') === 'image';
              }) ||
              article.media.find(el => {
                return get(el, 'settings.show.detail', true) === true && get(el, 'type') === 'image';
              }) ||
              this.product.media.find(el => {
                return get(el, 'settings.show.list', true) === true && get(el, 'type') === 'image';
              }) ||
              this.product.media.find(el => {
                return get(el, 'settings.show.datail', true) === true && get(el, 'type') === 'image';
              });

            // get property value IDs from current article
            const valueIDs = articlePivot.propertyValues.map(value => value.id);
            // if (!valueIDs.length) return;

            // get property sort from product property pivots
            let properties = [];
            this.product.propertyPivots.forEach(propertyPivot => {
              properties.push(propertyPivot.property.id);
            });

            // find matching article by id from cart-article
            // then get the property values from the matching article
            let propertyPivots = [];
            this.product.articles.forEach(el => {
              if (el.id === article.id) {
                el.propertyPivots.forEach(propertyPivot => {
                  if (properties.includes(propertyPivot.property.id)) {
                    const position = properties.findIndex(id => id === propertyPivot.property.id);
                    propertyPivots.push({
                      property: propertyPivot.property,
                      value: getOptionValue(propertyPivot.value, propertyPivot.property.propType),
                      position
                    });
                  }
                });
              }
            });

            // get product related property values

            this.product.propertyPivots.forEach(propertyPivot => {
              if (!propertyPivot.values || !propertyPivot.values.length) return;
              if (propertyPivot.property.article_required || !properties.includes(propertyPivot.property.id)) return;

              const position = properties.findIndex(id => id === propertyPivot.property.id);

              const option = propertyPivot.values.find(value => valueIDs.includes(value.id));
              if (!option) return;

              propertyPivots.push({
                property: propertyPivot.property,
                value: getOptionValue(option, propertyPivot.property.propType),
                position
              });
            });

            articlePivot.propertyPivots = propertyPivots;
            articlePivots.push(articlePivot);

            // qtyMap[article.id].cart += articlePivot.qty;
          });
        }
      });

      // go through articlePivots
      // and update the available value
      // based on actual available qty and current qty in cart

      // if (this.product.manage_stock) {
      //   articlePivots.forEach(articlePivot => {
      //     articlePivot.available = qtyMap[articlePivot.article.id].cart <= qtyMap[articlePivot.article.id].stock;
      //     articlePivot.qty_at_limit = qtyMap[articlePivot.article.id].cart === qtyMap[articlePivot.article.id].stock;
      //   });
      // }

      return orderBy(articlePivots, 'position');
    },
    ...mapGetters({
      customer: 'shop/customer',
      defaultCustomerGroup: 'shop/defaultCustomerGroup',
      cart: 'shop/cart'
    })
  },
  methods: {
    increase(articlePivot) {
      const { article, propertyValues } = articlePivot;
      this.addArticleToCart({ article, propertyValues });
    },
    decrease(articlePivot) {
      let qty = 1;
      if (!articlePivot.available && articlePivot.article.qty_sum <= 0) qty = articlePivot.qty;

      const { article, propertyValues } = articlePivot;
      this.removeArticleFromCart({ article, propertyValues, qty }).then(() => {
        if (this.qty <= 0) this.$emit('refresh-cart');
      });
    },
    ...mapActions({
      addMessage: 'message/add',
      addArticleToCart: 'shop/addArticleToCart',
      removeArticleFromCart: 'shop/removeArticleFromCart',
      fetchProductArticles: 'shop/fetchProductArticles'
    })
  }
};
</script>

<style lang="sass" scoped>
@import '~@/assets/sass/variables'
$media-height: 60px

.cart-product-summary
  &.not-available
    .title, .nr
      @apply text-red-500
  hr
    display: none
    @screen md
      display: block
      grid-column: 1 / 5
      margin-top: 2rem
  .article-pivot
    @apply grid
    grid-template-rows: auto 36px
    grid-template-columns: auto minmax(min-content, 90px) max-content
    grid-gap: 0.8rem
    grid-row-gap: 4px
    @screen md
      display: contents
    &.not-available
      @apply text-red-500
  .property-values
    grid-column: 1 / 4
    @screen md
      grid-column: 1
      margin: -2px
    .main-media
      @apply bg-gray-100
      margin: 2px
    .property-value
      @apply py-1 px-3 bg-gray-300 border-gray-300
      // background: none
      line-height: 1.1
      margin: 2px
      height: auto
      display: inline-block
      min-height: 46px
      padding: 4px
      padding-bottom: 8px
      border: none
      display: flex
      flex-direction: column
      justify-content: center
      @screen lg
        @apply py-2 px-4
      .small
        font-size: .8em
  .article-pivot > *
    display: flex
    align-items: center
    &.text-right
      justify-content: flex-end
    &.text-center
      justify-content: center
  .gray
    @apply text-gray-500

  .info
    @apply flex
    margin-bottom: .4rem
    .main-media
      @apply bg-gray-100
      margin-right: 4px
    .text-box
      @apply flex flex-col flex-grow justify-center
      .title, .nr, .description
        line-height: 1.3
      .title
        @apply text-2xl
      .nr
        @apply text-xs
        & + .description
          margin-top: .4rem

  a.info
    text-decoration: none
    color: var(--color-primary)
    &:hover, &:focus
      color: inherit
      .title
        text-decoration: underline

  .qty
    @apply relative
    padding-left: calc(2rem + 4px)
    padding-right: calc(2rem + 4px)
    grid-row: 2
    grid-column: 2
    @screen md
      grid-row: initial
      grid-column: initial
    .buttons
      @apply absolute flex justify-between
      top: calc(50% - 1rem + 1px)
      left: 0
      right: 0
      // display: none
      width: 100%
      height: 2rem
      button.button
        padding: .3rem
        width: 2rem
        height: 2rem
        & + button.button
          margin-left: 4px
    // &:hover
      color: transparent
      .buttons
        display: initial
  .sum
    // display: none
    // @screen md
    //   display: block
    grid-row: 2
    grid-column: 3
    @screen md
      grid-row: initial
      grid-column: initial
  .price
    // @apply text-black
    // font-weight: bold
    grid-row: 2
    grid-column: 1
    @screen md
      grid-row: initial
      grid-column: initial

.strikethrough
  // margin-right: 0.2rem
  font-size: 0.8em
  &:before
    border-top-width: 2px
    border-color: rgba(0,0,0,0.5)

.article-pivot .price
  // flex-direction: column
  // justify-content: center !important
  // align-items: flex-end
.sale
  color: $red
.gray .strikethrough
  opacity: 0.6

.price
  position: relative
  nobr.sale
    margin-left: 1rem
    color: theme('colors.red.600')
    position: relative
    z-index: 1
    &:before
      content: ''
      position: absolute
      // background-color: theme('colors.red.100')
      background-color: #e6ff15
      width: calc(100% + 8px)
      height: calc(100% + 4px)
      left: -4px
      top: -7px
      z-index: -1
      transform: rotate(-9deg) skew(-2deg, 0deg)
</style>
